import React, { useState } from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import ModalMarketingForm from 'components/ModalMarketingForm';
import RichTextImageMp4 from '../RichText/options/components/RichTextImageMp4';
import { isInternalLink, formatInternalLink } from 'utils/urlHelper';
import { Link } from 'gatsby';

const Ad = ({ className, url, modalForm, image, isRichText, ...otherProps }) => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  const Image = image ? (
    isRichText ? (
      <RichTextImageMp4 fields={image} />
    ) : (
      <WebsiteImage data-testid="ad-websiteimage" src={image} alt="Content Ad" />
    )
  ) : null;

  //modal takes precedent over link
  return (
    <>
      {modalForm ? (
        <div
          data-testid="ad-modal-form-container"
          style={{ cursor: 'pointer' }}
          className={className}
          onClick={() => toggleIsModalOpen(true)}
          {...otherProps}
        >
          {Image}
        </div>
      ) : isInternalLink(url) ? (
        <Link
          data-testid="ad-gatsby-link"
          className={className}
          to={formatInternalLink(url)}
          {...otherProps}
        >
          {Image}
        </Link>
      ) : (
        <a data-testid="ad-external-link" className={className} href={url} {...otherProps}>
          {Image}
        </a>
      )}
      {modalForm && (
        <ModalMarketingForm
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          onFormSuccess={() => toggleIsModalOpen(false)}
          {...(!isRichText
            ? { marketingForm: modalForm }
            : {
                formTitle: modalForm?.fields?.formTitle['en-US'],
                marketingForm: modalForm?.fields?.marketoForm['en-US'],
              })}
        />
      )}
    </>
  );
};

export default Ad;
